import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";

function CenteredPortraitCeoMessage() {
  const [hospitalAbout, setHospitalAbout] = useState({});
  const [expanded, setExpanded] = useState(false);
  const truncateLength = 770;
  const siteData = useSelector((store) => store.global.loginData);

  useEffect(() => {
    getHospitalAboutData();
  }, []);

  const getHospitalAboutData = async () => {
    try {
      const response = await SendPostRequest("content/aboutus");
      if (response?.data) {
        setHospitalAbout(response.data);
      }
    } catch (error) {
      console.error("Error fetching hospital about data:", error);
    }
  };

  const createMarkup = (html) => {
    return { __html: html };
  };

  const shouldTruncate =
    hospitalAbout?.ceo_description?.length > truncateLength;
  const displayContent = expanded
    ? hospitalAbout?.ceo_description
    : shouldTruncate
      ? truncateText(hospitalAbout?.ceo_description, truncateLength)
      : hospitalAbout?.ceo_description;

  function truncateText(text, maxLength) {
    if (!text) return "";
    return text.slice(0, maxLength) + "...";
  }
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {hospitalAbout?.ceo_description && hospitalAbout?.ceo_image && (
        <div id="carousel-section" className="carousel-section pad-none my-5">
          <div className="container">
            <div className="row animated fadeInLeft visible">
              
              <div
                className="col-lg-6 bg-1 ceo-message-padding bg-grey justify-content-center"
                data-animation="fadeInLeft"
              >
                <div className="row">
                  <div className="col-md-12">
                    <div className="title-wrap">
                      <div className="section-title margin-bottom-40">
                        <h2 className="title text-uppercase mb-0">
                          {siteData?.site_type === "hospitals" ? (
                            <>
                              CEO <span className="theme-color">Message</span>
                            </>
                          ) : (
                            <>
                              DOCTOR{" "}
                              <span className="theme-color">Message</span>
                            </>
                          )}
                        </h2>
                        <span className="section-border-bottom"></span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="feature-box-wrap f-box-style-1 relative">
                        <div className="feature-box-details">
                          <div className="feature-content">
                            {/* <div
                              dangerouslySetInnerHTML={createMarkup(
                                displayContent
                              )}
                            /> */}
                            <span
                              dangerouslySetInnerHTML={createMarkup(hospitalAbout?.ceo_description)}
                            />
                            {/* {shouldTruncate && (
                              <button
                                onClick={() => setExpanded(!expanded)}
                                className="btn btn-default mt-3"
                              >
                                {expanded ? "Read Less" : "Read More"}
                              </button>
                            )} */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-6 bg-2 p-0 div-bg-img justify-content-center"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                data-animation="fadeInRight"
              >
                <img
                  src={hospitalAbout.ceo_image}
                  alt="CEO Message"
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: isMobile ? "contain" : "cover",
                    objectPosition: "top center",
                  }}
                />
              </div>

            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CenteredPortraitCeoMessage;
